<script lang="ts" setup>
export interface Props {
  value?: string
  heading: string
  description: string
  selected?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  value: '',
  heading: '',
  description: '',
  selected: false,
  disabled: false
})

defineEmits<{
  (e: 'select', value: string): void
}>()
</script>

<template lang="pug">
.check-card.bg-white.drop-shadow-xl.py-3.px-4.rounded-lg.flex.items-center.gap-4(
  :class="{ 'opacity-50 drop-shadow-none': disabled }"
  @click="!disabled && $emit('select', value)"
)
  .icon.rounded-full.w-10.h-10.bg-slate-100.shrink-0.flex.items-center.justify-center(
    :class="{ 'bg-slate-500': props.selected }"
  )
    template(v-if="props.selected")
      include ../public/images/icons/check.svg

  .text
    p.text-lg.font-semibold(v-html="props.heading")
    p.text-sm.text-slate-500(v-html="props.description")
</template>

<style lang="sass">
.check-card
  svg path
    @apply fill-white
</style>
